var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { Urls } from '../../../enums/urls';
var OrderPlacedComponent = /** @class */ (function () {
    function OrderPlacedComponent() {
        this.viewModel = {
            title: 'Thank You!',
            message: 'Your order has been successfully placed',
            buttonText: 'ANOTHER ONE?',
            homeUrl: Urls.Home
        };
    }
    OrderPlacedComponent = __decorate([
        Component({
            selector: 'order-placed',
            template: require('./order-placed.component.html'),
            styles: [require('./order-placed.component.scss')]
        }),
        __metadata("design:paramtypes", [])
    ], OrderPlacedComponent);
    return OrderPlacedComponent;
}());
export { OrderPlacedComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JkZXItcGxhY2VkLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm9yZGVyLXBsYWNlZC5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQUcxQyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0scUJBQXFCLENBQUM7QUFPM0M7SUFHSTtRQUNJLElBQUksQ0FBQyxTQUFTLEdBQUc7WUFDYixLQUFLLEVBQUUsWUFBWTtZQUNuQixPQUFPLEVBQUUseUNBQXlDO1lBQ2xELFVBQVUsRUFBRSxjQUFjO1lBQzFCLE9BQU8sRUFBRSxJQUFJLENBQUMsSUFBSTtTQUNyQixDQUFDO0lBQ04sQ0FBQztJQVZRLG9CQUFvQjtRQUxoQyxTQUFTLENBQUM7WUFDUCxRQUFRLEVBQUUsY0FBYztZQUN4QixRQUFRLEVBQUUsT0FBTyxDQUFDLCtCQUErQixDQUFDO1lBQ2xELE1BQU0sRUFBRSxDQUFDLE9BQU8sQ0FBQywrQkFBK0IsQ0FBQyxDQUFDO1NBQ3JELENBQUM7O09BQ1csb0JBQW9CLENBV2hDO0lBQUQsMkJBQUM7Q0FBQSxBQVhELElBV0M7U0FYWSxvQkFBb0IifQ==